export const DISPOSE = 'SCENARIO_EVAL_TEMPLATE_EVALS_DISPOSE';
export const GET_EVAL_TEMPLATE_REQUEST = 'SCENARIO_EVAL_TEMPLATE_EVALS_GET_EVAL_TEMPLATE_REQUEST';
export const GET_EVAL_TEMPLATE_SUCCESS = 'SCENARIO_EVAL_TEMPLATE_EVALS_GET_EVAL_TEMPLATE_SUCCESS';
export const GET_EVALS_REQUEST = 'SCENARIO_EVAL_TEMPLATE_EVALS_GET_EVALS_REQUEST';
export const GET_EVALS_SUCCESS = 'SCENARIO_EVAL_TEMPLATE_EVALS_GET_EVALS_SUCCESS';
